export default "__VITE_ASSET__BPpBewR1__"